import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import { TeamsContext } from 'bundles/teams-v2/components/TeamsContainer';
import TeamsLegalDisclaimerItem from 'bundles/teams-v2/components/TeamsLegalDisclaimerItem';
import TeamsSocialProofItem from 'bundles/teams-v2/components/TeamsSocialProofItem';
import TeamsValuePropItem from 'bundles/teams-v2/components/TeamsValuePropItem';

export function TeamsValueItem() {
  const location = useLocation();
  const path = location.pathname?.split('/').pop();

  const { promotion, enterprisePromotion } = React.useContext(TeamsContext);

  const hasPromotion = !!(promotion && enterprisePromotion);

  if (path === 'plan') {
    return <TeamsValuePropItem />;
  }
  if (path === 'account') {
    return <TeamsSocialProofItem />;
  }
  if (path === 'billing') {
    return <TeamsLegalDisclaimerItem isDiscounted={hasPromotion} />;
  }

  // Should not be possible but required for type
  return null;
}

export default TeamsValueItem;
